module.exports = __webpack_public_path__ + "static/media/eastlogo2.c89830f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/eastlogo2.jpg
// module id = 999
// module chunks = 8